import React, { useState, useEffect, useMemo } from "react"

import { Button, InputNumber, Radio } from "antd"
import _ from "lodash"

import { updateFilterItemInList } from "../../../../../../../helpers/utils/reports"
import { useActions } from "../../../../../hooks/useActions"
import { useForceUpdate } from "../../../../../hooks/useForceUpdate"
import { useTypedSelector } from "../../../../../hooks/useTypedSelector"

const NumberPicker = ({ disabled = false, id, index, modalVisibleHandler, ...props }: any) => {
    const forceUpdate = useForceUpdate()

    const { filters } = useTypedSelector((state) => state.filter)
    const { setFilters, setFilter, setMetaFilterUpdate } = useActions()

    const [ isEditing, setIsEditing ] = useState(false)
    const [ filterMode, setFilterMode ] = useState(1)
    const [ _id, _setId ] = useState(id)

    useEffect(() => {
        forceUpdate()
    }, [ props.itemData, index, id ])

    useEffect(() => {
        let _tempId = id

        if (filterMode === 2) {
            setFilterMode(2)
            if (!id.includes("not_")) {
                _tempId = `not_${id}`
            }
        } else {
            setFilterMode(1)
            if (id.includes("not_")) {
                _tempId = id.split("not_")[1]
            } else {
                _tempId = id
            }
        }

        _setId(_tempId)
    }, [ id, filterMode ])

    useEffect(() => {
        if (id.includes("not_")) {
            setFilterMode(2)
        } else {
            setFilterMode(1)
        }
    }, [])

    const filter = useMemo(() => {
        let _filter = props.itemData ? props.itemData : null
        if (!props.list) {
            _filter = null
        } else if (!isEditing) {
            setIsEditing(true)
        }

        return _filter ? _filter : { ...props, number: null }
    }, [ filters, _id, index, props.list, props.itemData, props ])

    const [ currentData, setCurrentData ] = useState(filter)

    const onApply = () => {
        let _currentData = {
            ...currentData,
            id: _id?.toString()
        }

        if (isEditing) {
            let _filters = _.cloneDeep(filters)

            const payload = { ..._currentData }
            _filters = updateFilterItemInList(_filters, index, payload)

            setFilters(_filters)
            setMetaFilterUpdate({value:true})
            modalVisibleHandler(false)

            return
        }

        const payload = {
            ..._currentData,
            id: _id?.toString()
        }

        setFilter(payload)
        setMetaFilterUpdate({value:true})
        modalVisibleHandler(false)
    }

    const onChange = (val: number | null) => {
        console.log(val)
        let _val = val

        if ([ "applications_payments_orders_days_end", "applications_payments_reg_days_end", "webinar_reg_days_end", "applications_users_days_end" ].includes(id)) {
            if (typeof _val !== "number" || _val < 1) {
                _val = 1
            }
        }

        setCurrentData((prevState: any) => {
            return {
                ...prevState,
                number: _val?.toString()
            }
        })
    }

    return (
        <div>

            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Radio.Group disabled={disabled} onChange={(e) => setFilterMode(e.target.value)} value={filterMode}>
                    <Radio value={1}>Включить</Radio>
                    <Radio value={2}>Исключить</Radio>
                </Radio.Group>
            </div>

            <InputNumber stringMode disabled={disabled} value={currentData.number} onChange={onChange} min={0} style={{ width: 200 }} />
            <br />
            <Button disabled={disabled} type="primary" style={{ marginTop: 10 }} onClick={onApply}>
                Применить
            </Button>
        </div>
    )
}

export default NumberPicker
